<template>
    <input 
    type="file"
    @change="readFile"
    @click="$event.target.value=''"
    ref="excelUpload" 
    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
</template>
    


<script setup>
import * as XLSX from 'xlsx';
import {reactive,ref} from 'vue'
import common from '@/js/common';

const excelUpload = ref()
const emits = defineEmits(['return'])

const props = defineProps({
    headerKeys : {
        type : Array,
        default : []
    },
    dataFormat :{
        type : Boolean,
        default : true
    }
})

const state = reactive({
    visibleHeadProps : null,
    instance : undefined,
})

const selectUploadFile = () => {
    excelUpload.value.click()
}

const resetUploadFile = () => {
    excelUpload.value.value = '';
}

const readFile = (event) =>{
    let returnData = new Object()
    returnData.file = event.target.files[0];
    const file = event.target.files[0];

    let reader = new FileReader();
    let tmpResult = [];
    reader.onload = (e) => {
        let data = reader.result;
        let workBook = XLSX.read(data, { type: 'binary', cellDates: true });
        workBook.SheetNames.forEach(sheetName => {
            if(props.headerKeys.length > 0){
                let asciiNum = 65
                for(let i=0; i<props.headerKeys.length; i++){
                    let capital = String.fromCharCode(asciiNum + i) + '1';

                    if(workBook.Sheets[sheetName][capital]?.w && workBook.Sheets[sheetName][capital]?.w != null && workBook.Sheets[sheetName][capital]?.w != undefined){
                        workBook.Sheets[sheetName][capital].w = props.headerKeys[i]

                    }
                }
            }
            const roa = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
            tmpResult.push(roa)
        });
        //emit을 통하여 부모창에게 읽은 엑셀파일을 전달한다.
        returnData.sheets = tmpResult
        emits('return',returnData) 
    };
    reader.readAsBinaryString(file);
}


const excelDownload = (fileName,header,dataList,headerProps) =>{
    let options = { 
        header: header,
        headProps: headerProps ? headerProps : 'header' 
    }
    // data row별 header에 바인딩 될 매핑값 설정 
    let headProps = []

    if (Array.isArray(options.headProps)){
        headProps = options.headProps
    }else if(options.headProps === 'header'){
        for(let h of header){
            headProps.push(h.field)
        }
    } else {
        headProps = Object.keys(dataList[0])
    }

    state.visibleHeadProps = headProps 
    state.instance = document.createElement('table')

    // Header 세팅
    let headerSet = []

    if(!Array.isArray(header[0])){
        headerSet.push(header)
    }else{
        headerSet = header
    }

    let thead = document.createElement('thead')

    for(let row of headerSet){
        let tr = document.createElement('tr')

        for(let h of row){
                let rowspan = h.rowspan || '1' 
                let colspan = h.colspan || '1'
                let th = document.createElement('th') 
                th.setAttribute('rowspan',rowspan)
                th.setAttribute('colspan',colspan)
                th.innerText = h.headerName ? h.headerName : h.header
                tr.appendChild(th) 
        }

        thead.appendChild(tr)
    }

    state.instance.appendChild(thead)


    // Body 세팅
    let tbody = document.createElement('tbody')

    for(let row of dataList) {
        let tr = document.createElement('tr') 
        for(let cellkey of state.visibleHeadProps){ 
            let td=document.createElement('td') 
            if(row[cellkey] == undefined){
                td.innerText = ''
            }else{
                td.innerText = row[cellkey] 
            }
            tr.appendChild(td)
        } 

        tbody.appendChild(tr) 
    } 

    state.instance.appendChild(tbody) 
    
    // instance에 만들어진 table을 엑셀파일로 저장
    let config = {
        raw: true,
        type:'string'
    } 

    let ws = XLSX.utils.table_to_sheet(state.instance,config)
    Object.keys(ws).filter((key1)=>{
        if(typeof ws[key1] === 'object'){
            return true
        }
    }).forEach((key)=>{
        if(props.dataFormat) {
            //숫자형은 cell type 숫자형으로 수정
            /**
                b	: Boolean
                e	: Error
                n	: Number
                d	: Date
                s	: Text
                z	: Stub
            */
            if(ws[key]?.v && typeof ws[key] === 'object'){
                let type = 's'

                if(!isNaN(Number(ws[key]['v']))){
                    ws[key]['v'] = Number(ws[key]['v']); // 명시적으로 숫자로 변환
                    type = 'n'; // 타입 설정
                    if (Number.isInteger(ws[key]['v'])) {
                        ws[key]['z'] = '#,##0'; // 정수 형식 설정
                    } else {
                        type = 'g'; // 소수인 경우 일반 형식
                    }
                    ws[key]['t'] = type
                }else if(ws[key]['v'].substring(ws[key]['v'].length-1) === '%'){
                    const cellData = ws[key]['v'].substring(0,ws[key]['v'].length-1).replaceAll('-','')
                    if(common.checkNumber(cellData) || common.checkFloat(cellData)){
                        //문자열중에 퍼센트(%) 포멧팅인 경우 type 숫자
                        type = 'n'
                        if(props.dataFormat) ws[key]['z'] = "0.0%"
                        ws[key]['v'] = (Number(ws[key]['v'].substring(0,ws[key]['v'].length-1)) / 100).toFixed(4)
                    }
                    ws[key]['t'] = type
                }else if(common.checkDateForm(ws[key]['v'])){ 
                       //날짜형식 시분초 제외하고 표출 
                        
                        
                         // 날짜 문자열을 Date 객체로 변환
                        // const dateValue = new Date(ws[key]['v']);
                        const [year, month, day] = ws[key]['v'].split("-").map(Number);
                        const newDate = new Date(Date.UTC(year, month - 1, day,0,0,0)); // 시간대를 UTC로 설정
                        
                        // xlsx 라이브러리에 맞게 날짜를 Excel 날짜 형식으로 변환
                        ws[key]['v'] = (newDate - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000); 
                        ws[key]['t'] = 'n';
                        ws[key]['z'] = "yyyy-mm-dd"
                }
                
            }
        }else{
            ws[key]['t'] = 's'
        }

    })
    
    let wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb,ws,fileName)
    autofitColumns(ws)
    XLSX.writeFile(wb,fileName+'.XLSX')

}

function getEndingDigit(inputString) {
  const regex = /\d+$/;

  if (regex.test(inputString)) {
    const match = inputString.match(regex);
    return match[0].replace(/\D/g, '');
  }

  return null;
}

function autofitColumns(worksheet) {
  let objectMaxLength = [];

  const [startLetter, endLetter] = worksheet['!ref']?.replace(/\d/, '').split(':')
  const ranges = []

  let startIdx = startLetter.charCodeAt(0)
  let endIdx = 0;

  const regex = /^[A-Z]$/;
  [...endLetter].forEach((char,index)=>{
    if(regex.test(char)){
        endIdx = char.charCodeAt(0) + (index * 26)
    }
  })

  for(let i =startIdx; i<(endIdx + 1); i++){
    ranges.push(i)
  }

  ranges.forEach((c) => {
    const cellHeader = String.fromCharCode(c)

    let maxCellLengthForWholeColumn = Array.from(
      { length: getEndingDigit(worksheet['!ref']) },
      (_, i) => i
    ).reduce((acc, i) => {
      const cell = worksheet[`${cellHeader}${i + 1}`]

      // empty cell
      if (!cell) return acc
      const charLength = typeof cell.v === 'number' ? cell.v.toString().length+3 : cell.v.length + 7  

      return acc > charLength ? acc : charLength
    }, 0)
    if(maxCellLengthForWholeColumn === 0) maxCellLengthForWholeColumn = 10
    objectMaxLength.push({ wch: maxCellLengthForWholeColumn })
  })
  worksheet['!cols'] = objectMaxLength
}

    
defineExpose({
    state,
    selectUploadFile,
    readFile,
    excelDownload,
    resetUploadFile
})
</script>